import {SharedModule} from '../../../shared/shared.module';
import {AssociationsListComponent} from './associations-list.component';
import {AssociationsListResolver} from './associations-list.resolver';
// import {AssociationsForFilterResolver} from '../associations-for-filter/associations-for-filter.resolver';
import {CategoryAssociationsResolver} from './category-associations.resolver';
import {NgModule} from '@angular/core';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { DataTableModule } from 'angular-datatables-all-versions';

@NgModule({
  imports: [
    NgbModule,
    SharedModule,
    DataTableModule
  ],
  declarations: [AssociationsListComponent],
  exports: [AssociationsListComponent],
  providers: [AssociationsListResolver, CategoryAssociationsResolver]
})
export class AssociationsListModule {}
